import { TResApi, TResApiErr, TResDataListApi } from '@src/configs/interface.config'
import { checkAuth } from '@src/libs/localStorage'
import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import { NError, NSuccess } from '@src/configs/const.config'
import { TQuerySpecial, TSpecialDeal } from '@src/modules/special-deal'
import { DETAIL_SPECIAL_DEAL, LIST_SPECIAL_DEAL, TOTAL_SPECIAL_DEAL } from '@queries/keys'
import {
  CreateSpecialDeal,
  getLisSpecialDeal,
  getSpecialDealById,
  getSpecialDealTotal,
  patchSpecialDealById,
  removeSpecialDealById,
  removeSpecialDealByIds,
} from '@queries/apis'

import { queryClient } from '..'

export const useQueryListSpecialDeal = (params: TQuerySpecial, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResDataListApi<TSpecialDeal[]>>(
    [LIST_SPECIAL_DEAL, JSON.stringify(params)],
    () => getLisSpecialDeal(params, accessToken),
    {
      enabled: !!accessToken,
    },
  )
}

export const useMutationRemoveDealById = () =>
  useMutation(removeSpecialDealById, {
    onSuccess: (res: TResApi, id) => {
      queryClient.refetchQueries([LIST_SPECIAL_DEAL]).then()
      queryClient.removeQueries([DETAIL_SPECIAL_DEAL, id])
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })
export const useQuerySpecialDealById = (id: string, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TSpecialDeal>>([DETAIL_SPECIAL_DEAL, id], () => getSpecialDealById(id, accessToken), {
    enabled: !!accessToken && !!id,
  })
}
export const useMutationPostSpecialDeal = () =>
  useMutation(CreateSpecialDeal, {
    onSuccess: (res: TResApi<TSpecialDeal>) => {
      queryClient.refetchQueries([LIST_SPECIAL_DEAL]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })
export const useMutationPatchSpecialDealById = () =>
  useMutation(({ id, data }: { id: string; data: TSpecialDeal }) => patchSpecialDealById(id, data), {
    onSuccess: (res: TResApi, { id }) => {
      queryClient.refetchQueries([LIST_SPECIAL_DEAL]).then()
      queryClient.invalidateQueries([DETAIL_SPECIAL_DEAL, id]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })
export const useMutationRemoveManySpecialDeal = () =>
  useMutation(removeSpecialDealByIds, {
    onSuccess: (res: TResApi) => {
      queryClient.refetchQueries([LIST_SPECIAL_DEAL]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
  })
export const useQuerySpecialDealTotal = (token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<number>>([TOTAL_SPECIAL_DEAL], () => getSpecialDealTotal(token as string), {
    enabled: !!accessToken,
  })
}
